var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 10.5858L14.2929 4.29289L15.7071 5.70711L9.41418 12L15.7071 18.2929L14.2929 19.7071L7.99997 13.4142C7.21892 12.6332 7.21892 11.3668 7.99997 10.5858Z",
    fill: "#394149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSimple);
export default __webpack_public_path__ + "static/media/left-arrow-simple.f4f076b1e6a1cebee2ff5813c23cccad.svg";
export { ForwardRef as ReactComponent };